module.exports = __webpack_public_path__ + "assets/img/logoFour.08971dea.png";